import { Typography } from '@/components';
import { ConnectEmailMethod, TextStyles } from '@/constants';
import { ConnectGoogleButton } from '@/modules/pmt/components/ConnectGoogleButton';
import { useMyParcelsContext } from '@/modules/pmt/context';
import { gtmClickEsyncCta, gtmConnectEmailSuccess, gtmViewEsyncCta } from '@/utils';
import { useStatsigClient } from '@statsig/react-bindings';
import { useEffect } from 'react';
import { LOGGED_IN_ES_BANNER_IMAGE } from '../../constants';
import { useLoggedInESBannerCopy } from '../../hooks';
import { fallbackToImage } from '../../utils';
import {
  BannerTitle,
  ContentWrapper,
  EmailSyncBannerGraphic,
  EmailSyncWrapper,
  GmailStyleButton,
} from './LoggedInEsBanner.styles';

export const LoggedInESBanner = () => {
  const { notificationTranslation } = useMyParcelsContext();
  const { identifier } = notificationTranslation;
  const { logEvent } = useStatsigClient();
  const { description: bannerDescription, cta: bannerCta, imageUrl, groupName } = useLoggedInESBannerCopy();

  // biome-ignore lint/correctness/useExhaustiveDependencies: intentional mount-only effect
  useEffect(() => {
    gtmViewEsyncCta({ variant: identifier });
  }, []);

  return (
    <EmailSyncWrapper>
      <EmailSyncBannerGraphic
        alt='Email sync banner device'
        src={imageUrl}
        onError={fallbackToImage(LOGGED_IN_ES_BANNER_IMAGE)}
      />
      <ContentWrapper>
        <BannerTitle>{bannerDescription}</BannerTitle>
        <ConnectGoogleButton
          buttonComponent={({ onClick }) => (
            <GmailStyleButton onClick={onClick}>
              <Typography variant={TextStyles['Button']}>{bannerCta}</Typography>
            </GmailStyleButton>
          )}
          handleClick={() => {
            gtmClickEsyncCta({ variant: identifier });
            logEvent('click_esync_cta', undefined, {
              ...(groupName !== null && { variant: groupName }),
            });
          }}
          onSuccess={() => {
            gtmConnectEmailSuccess(ConnectEmailMethod.EsyncCta);
            logEvent('connect_email_success');
          }}
        />
      </ContentWrapper>
    </EmailSyncWrapper>
  );
};
